import React from "react";
import { Alert, Tooltip } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const guidance = {
  flat: "Flat: deducts the fixed value you enter each time this slab is triggered. Example: 500 deducts Rs. 500.",
  percentage: "Percentage: deducts the percentage you enter from the selected salary formula (or from the balance when Salary is off). It does not change with the number of late/short minutes in a daily slab.",
  as_per_actual: "As Per Actual: deducts in proportion to the actual deductible minutes. Use it when a longer late arrival or early leave should result in a larger deduction.",
};

export const DeductionTypeLabel = () => (
  <span>
    Deduction calculation method <Tooltip title="Choose how payroll should calculate a policy slab deduction."><InfoCircleOutlined className="da-ml-4" /></Tooltip>
  </span>
);

const DeductionTypeGuidance = ({ type }) => (
  <Alert
    className="da-mb-16"
    type="info"
    showIcon
    message={ guidance[type] || guidance.flat }
  />
);

export default DeductionTypeGuidance;
